/**
 * Property shapes for the support hub events: the floating help button and the
 * support modal it opens. Event names live in `SelfServeRawEventName` and
 * `SelfServeEventName`; schemas are in power-loader `eventschema/b2bportal_events.py`.
 */

/** What opened the support hub. Only sent on `support_hub_viewed`. */
export enum SupportHubSource {
  help_launcher = "help_launcher",
  cancellation_error = "cancellation_error",
  manage_booking = "manage_booking",
  cancel_side_panel = "cancel_side_panel",
}

/** Where the floating help button sent the user. */
export enum SupportHubDestination {
  support_hub = "support_hub",
  hts_assist = "hts_assist",
}

/** The support hub view showing when it closed. */
export type SupportHubView = "menu" | "contact" | "faq";

// Property shapes must be `type` aliases, not `interface` — the tracking `AEvent`
// constraint needs `Record<string, unknown>`, which interfaces don't satisfy.

/**
 * On every support hub event. `product` and `reservation_id` are only set when
 * the event fires from a booking's trip-details page.
 */
export type SupportHubCommonProperties = {
  entry_point?: string;
  product?: string;
  reservation_id?: string;
};

export type SupportHubHelpLaunchedProperties = SupportHubCommonProperties & {
  destination: SupportHubDestination;
};

export type SupportHubViewedProperties = SupportHubCommonProperties & {
  source?: SupportHubSource;
};

export type SupportHubDismissedProperties = SupportHubCommonProperties & {
  last_view: SupportHubView;
};
